import { CIcon } from '~/icons/types'

export const ciTrash: CIcon = {
  width: '20',
  height: '20',
  paths: [
    {
      d:
        'M10 2.71c-.454 0-.907.007-1.357.021a.977.977 0 0 0-.927.875 41.468 41.468 0 0 1 4.568 0 .977.977 0 0 0-.927-.875A43.67 43.67 0 0 0 10 2.71Zm3.958 1.022c0-1.41-1.094-2.62-2.548-2.667a44.115 44.115 0 0 0-2.82 0c-1.454.047-2.548 1.257-2.548 2.667a40.869 40.869 0 0 0-3.06.412.833.833 0 0 0 .233 1.65l.82 10.665a2.708 2.708 0 0 0 2.701 2.5h6.528a2.708 2.708 0 0 0 2.7-2.5l.82-10.666a.833.833 0 0 0 .233-1.65 40.741 40.741 0 0 0-3.059-.41Zm1.174 1.81A39.305 39.305 0 0 0 10 5.21a39.72 39.72 0 0 0-5.132.333l.83 10.788a1.04 1.04 0 0 0 1.038.962h6.528c.544 0 .997-.42 1.038-.962l.83-10.788ZM7.684 6.67c.46-.018.847.34.865.8l.289 7.5a.833.833 0 1 1-1.666.064l-.288-7.5a.833.833 0 0 1 .8-.864Zm4.632 0c.46.017.818.404.8.864l-.288 7.5a.833.833 0 0 1-1.666-.064l.289-7.5a.833.833 0 0 1 .865-.8Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'trash',
  type: 'regular'
}
